import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const Unauthorized: React.FC = () => {
  return (
      <div className="mx-auto bg-white p-24 flex flex-col justify-center">
        <div className="text-9xl font-bold flex items-center align-middle mx-auto">
          <span>4</span>
          <span className="flex items-center align-middle"><FontAwesomeIcon className="text-8xl" icon={faLock} /></span>
          <span>3</span>
        </div>
        <div className="inter-font mt-4">
          Oops! You don't have permission to access this content.
        </div>
        <div className="mt-2 text-sm text-muted">
          If you think that you are supposed to have access to this content, please check with your administrator or try again later.
        </div>
      </div>
      );
};

      export default Unauthorized;
